import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ProvideAuth } from './hooks/useAuth';
import { GoogleTag } from 'organisms/u002/audition-form/GoogleTag';
import GoogleRecaptcha from './googleRecaptcha';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <GoogleRecaptcha>
      <ProvideAuth>
        <BrowserRouter>
          <GoogleTag.Provider>
            <App />
          </GoogleTag.Provider>
        </BrowserRouter>
      </ProvideAuth>
    </GoogleRecaptcha>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
